import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

const ACCENTS = ["border-zinc-700", "border-sky-500/40", "border-amber-500/40"];
const DOTS = ["bg-zinc-400", "bg-sky-400", "bg-amber-400"];

export function TiersSection() {
  const { t } = useLang();
  const levels = t("tiers.levels");

  return (
    <section id="livelli" data-testid="tiers-section" className="relative z-10 bg-[#050505] py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="max-w-3xl mb-16 md:mb-20">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{t("tiers.overline")}</span>
          <h2 className="font-display font-bold tracking-[-0.02em] text-white text-4xl md:text-5xl lg:text-6xl mt-5 leading-[1.02]">{t("tiers.heading")}</h2>
          <p className="mt-6 text-lg text-zinc-400 max-w-xl leading-relaxed">{t("tiers.subtitle")}</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {levels.map((lv, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <article
                data-testid={`tier-card-${i}`}
                className={`group h-full rounded-2xl border ${ACCENTS[i]} bg-aura-surface p-8 flex flex-col hover:-translate-y-1 transition-transform duration-300 ${i === 2 ? "ring-1 ring-amber-500/20" : ""}`}
              >
                <div className="flex items-center gap-2 mb-6">
                  <span className={`h-2 w-2 rounded-full ${DOTS[i]}`} />
                  <span className="text-xs uppercase tracking-[0.2em] text-zinc-500">{lv.label}</span>
                </div>
                <h3 className="font-display text-3xl font-bold text-white">{lv.name}</h3>
                <ul className="mt-7 space-y-3">
                  {lv.perks.map((p, j) => (
                    <li key={j} className="flex items-start gap-3 text-zinc-300 text-sm">
                      <Check size={16} className="mt-0.5 text-white shrink-0" /> {p}
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
